module.exports = __webpack_public_path__ + "img/mapbg.837e99ea.png";